module.exports = __webpack_public_path__ + "media/burial-document_2400.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/burial-document_2400.jpg
// module id = 15
// module chunks = 0